import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {SDIR_IMAGES} from '../../../../projects/api/src/dataset/dataset.service';
import {CircleMode, CircleSize} from '@inspark/inspark-components/interface';
import {environment} from '../../../environments/environment';
import {InlineSVGConfig} from 'ng-inline-svg';



@Component({
  selector: 'in-state-circle',
  templateUrl: './state-circle.component.html',
  styleUrls: ['./state-circle.component.scss'],
  providers: [
    {provide: InlineSVGConfig, useValue: {baseUrl: 'assets/images/'}}
  ],
  encapsulation: ViewEncapsulation.Emulated
})
export class StateCircleComponent implements OnChanges, OnInit {


  @Input() mode: CircleMode = 'none';
  @Input() size: CircleSize = 'normal';
  @Input() stateId: number;
  @Input() typeId: number;
  @Input() label: string;
  @Input() content: string;
  @Input() black = false;

  icon = '';

  ngOnInit() {
    this.updateIcon();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.stateId && changes.stateId.previousValue !== changes.stateId.currentValue) {
      this.updateIcon();
    }
  }

  updateIcon() {
    if (SDIR_IMAGES[this.stateId]) {
      this.icon = 'scopes/' + SDIR_IMAGES[this.stateId];
    } else if (this.typeId) {
      this.icon = `${environment.backEndUrlPrefix + '/'}db/icon/${this.typeId}/img`;
    } else {
      this.icon = null;
    }
  }
}
